/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Offline_NoteInputs */

const en_us2_workout_after_offline_note = /** @type {(inputs: Workout_After_Offline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved on this device. It syncs when the connection is back.`)
};

const pt_br2_workout_after_offline_note = /** @type {(inputs: Workout_After_Offline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvo neste aparelho. Sincroniza quando voltar a conexão.`)
};

const es_419_workout_after_offline_note = /** @type {(inputs: Workout_After_Offline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardado en este dispositivo. Se sincroniza cuando vuelva la conexión.`)
};

const pt_pt2_workout_after_offline_note = /** @type {(inputs: Workout_After_Offline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardado neste dispositivo. Sincroniza quando a ligação voltar.`)
};

const fr_fr2_workout_after_offline_note = /** @type {(inputs: Workout_After_Offline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistré sur cet appareil. La synchronisation se fera au retour de la connexion.`)
};

const de_de2_workout_after_offline_note = /** @type {(inputs: Workout_After_Offline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf diesem Gerät gespeichert. Wird synchronisiert, sobald die Verbindung zurück ist.`)
};

const it_it2_workout_after_offline_note = /** @type {(inputs: Workout_After_Offline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvato su questo dispositivo. Si sincronizza quando torna la connessione.`)
};

/**
* | output |
* | --- |
* | "Saved on this device. It syncs when the connection is back." |
*
* @param {Workout_After_Offline_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_offline_note = /** @type {((inputs?: Workout_After_Offline_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Offline_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_offline_note(inputs)
	if (locale === "es-419") return es_419_workout_after_offline_note(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_offline_note(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_offline_note(inputs)
	if (locale === "de-DE") return de_de2_workout_after_offline_note(inputs)
	if (locale === "it-IT") return it_it2_workout_after_offline_note(inputs)
	return en_us2_workout_after_offline_note(inputs)
});
export { workout_after_offline_note as "workout-after.offline_note" }